document.addEventListener("algolia.hooks.initialize", () => {
  algoliaShopify.hooks.registerHook(
    "beforeRecommendHitTemplate",
    (_defaultTemplate, html, item) => {
      // Return custom HTML using template literals
        const price = item.price / 100;
        const compareAtPrice = item.compare_at_price ? item.compare_at_price / 100 : null;
        const onSale = compareAtPrice && compareAtPrice > price;
        const discount = Math.round(((compareAtPrice - price) / compareAtPrice) * 100);
        const isAvailable = item.inventory_available;
        const isPetite = item.tags.includes("petite");
      return html`
        <div class="custom-recommend-card" id="${item.objectID}">
            <div class="no-stock ${isAvailable ? 'hide':''}">
              <button type="button" class="btn btn--full sold-out js-modal-open-oosmodal" data-sold-out-btn="" aria-expanded="false">
                <span data-add-to-cart-text="" data-default-text="Add to cart">
                  Get Notified
                </span>
              </button>
            </div>
            <div class="grid-product__tag grid-product__tag--amount-saving ${onSale ? '':'hide'}">
                ${onSale ? discount : ''}% Off
            </div>
            <div class="product-image-wrap">
                <img src="${item.product_image}" alt="${item.title}" />
                <div class="grid-product__band grid-product__band--petite ${isPetite ? '': 'hide'}">Petite</div>
            </div>
            <div class="product-meta grid-product__meta">
                <div class="grid-product__title grid-product__title--heading">${item.title}</div>
                <div class="price">
                    <span class="price ${item.compare_at_price != 0 ? 'on-sale' : ''}">$${item.price.toFixed(2)}</span>
                    <span class="compare-price ${item.compare_at_price != 0 ? '' : 'hide' }">$${item.compare_at_price.toFixed(2)}</span>
                </div>
            </div>
            <div class="grid-product__sizes hide">
              <span class="grid-product__sizes-label">Size</span>
              <span class="grid-product__sizes-range">${item.options.size}</span>
            </div>
            <a title="${item.title}" href="/products/${item.handle}"></a>
        </div>
      `;
    }
  );
});